import React from 'react';

import { css } from 'Libs/css/extended-styles';

import styles, { pulseAnimation } from './ItemSkeleton.styles';

const ItemSkeleton: React.FC = () => {
  return (
    <div style={styles.wrapper}>
      <div className={css(pulseAnimation)} style={styles.containerImage} />

      <div style={styles.containerInfos}>
        <div style={styles.containerHeader}>
          <div style={styles.containerHeaderLeft}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={css(pulseAnimation)} style={styles.typeBar} />
            </div>
            <div className={css(pulseAnimation)} style={styles.titleBar} />
            <div className={css(pulseAnimation)} style={styles.statusBar} />
          </div>
        </div>

        <div style={styles.containerFooter}>
          <div style={styles.containerFooterLeft}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={css(pulseAnimation)} style={styles.footerBar} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={css(pulseAnimation)} style={styles.footerBarShort} />
            </div>
          </div>
          <div style={styles.containerFooterRight}>
            <div style={{ display: 'flex' }}>
              <div className={css(pulseAnimation)} style={styles.flagBar} />
              <div className={css(pulseAnimation)} style={styles.flagBar} />
              <div className={css(pulseAnimation)} style={styles.flagBar} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemSkeleton;
